import env from '@shared/env.js'
import ROUTE from '@shared/modules/assessment/router/names'
import {
  MSK_PRE_SIGNUP_STEPS,
  MSK_PRE_SUBSCRIPTION_STEPS,
} from '@shared/modules/assessment/router/selfTestStepSets.js'
import useAuthStore from '@shared/stores/useAuthStore.js'
import useUserStore from '@shared/stores/useUserStore'
import usePreSubscriptionWebOptimizedFunnel from '@shared/composables/usePreSubscriptionWebOptimizedFunnel'

export default async (routeTo) => {
  const authStore = useAuthStore()
  const userStore = useUserStore()
  const preSubscriptionWebOptimizedFunnel =
    usePreSubscriptionWebOptimizedFunnel()

  switch (routeTo.name) {
    case ROUTE.ASSESSMENT_LOGIN:
      return true

    default:
      if (!authStore.isAuthenticated) {
        if (
          preSubscriptionWebOptimizedFunnel.value &&
          MSK_PRE_SIGNUP_STEPS.includes(routeTo.name)
        ) {
          return true
        }

        console.log(
          'Assessment User is not authenticated, redirecting to login',
        )
        return {
          name: ROUTE.ASSESSMENT_LOGIN,
          query: routeTo.query,
        }
      }

      // The self-test entry route is always the welcome route, but a user
      // without a subscription starts at the first step of their set: the MSK
      // EU pre-activation set or the legacy pre-subscription set.
      if (
        routeTo.name === ROUTE.ASSESSMENT_SELF_TEST_WELCOME &&
        !userStore.user?.currentSubscription
      ) {
        if (env.isMskEu) {
          return {
            name: MSK_PRE_SIGNUP_STEPS[0],
            query: routeTo.query,
            replace: true,
          }
        }
        if (!preSubscriptionWebOptimizedFunnel.value) {
          return {
            name: MSK_PRE_SUBSCRIPTION_STEPS[0],
            query: routeTo.query,
            replace: true,
          }
        }
      }
  }
}
